// import { Grid } from "@material-ui/core";
// import React from "react";
// import "./PrivacyPolicy.css";
// // import Grid from '@mui/material/Grid';

// export default function PrivacyPolicy() {
//   return (
//     <Grid style={{ minHeight: "100vh" }} container>
//       <div className="privacy_policy">
//         <div>
//           <div className="privacy_title">
//             <div>
//               <h3>Parlay Roial, LLC </h3>
//             </div>
//             <div>
//               <h3>PRIVACY POLICY </h3>
//             </div>
//           </div>
//           <div className="privacy_info">
//             <p>
//               Parlay Roial, LLC complies with all applicable privacy laws. Our
//               Privacy Policy is intended to explain how we collect and use
//               personal data that may be collected when you use our websites and
//               to alert you to the rights you may have to control how the
//               personal data is collected and used. “Parlay,” “we,” “our” and
//               “us” refer to Parlay Roial, LLC, and “you” and “yours” refers to
//               visitors and users of our website.
//             </p>
//           </div>
//           <div className="privacy_info_heading">
//             <p>
//               <span className="privacyinfo_head_des">1. Website:</span> Our
//               Terms of Use and Privacy Policy apply to the website located at
//               [Insert URL here]. The owner of the website is Parlay Roial Inc.
//               To contact us, please send an email to
//               <span
//                 style={{
//                   fontWeight: "bold",
//                 }}
//               >
//                 [Insert email address here].
//               </span>
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">
//                 2. Most Recent Update:
//               </span>
//               Our Terms of Use and Privacy Policy were last updated on July 28,
//               2021. Please return to our Terms of Use and Privacy Policy to find
//               out if we have made any changes since your last visit.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">
//                 3. Consent to Use of Cookies:
//               </span>
//               Like virtually all websites, our website uses “cookies” that are
//               automatically installed on your computer when you visit our
//               website. Cookies are small text files that are stored on your
//               computer and can be recognized when you return to our website.
//               Some cookies are installed by the service providers who host and
//               maintain our website or advertisers. Some of your personal data
//               will be collected by the cookies. On the landing page, you will be
//               given an opportunity to consent (or “opt in”) to the use of
//               cookies. If you do not opt in, or if you opt in but you later
//               remove or disable the cookies, the website will not be fully
//               functional.
//             </p>
//             <p>
//               <span className="privacyinfo_head_des">
//                 4. Consent to Terms of Use and Privacy Policy:
//               </span>
//               When you purchase products or services from Parlay Roial through
//               our website, you will be asked to confirm that you agree to be
//               bound by our Terms of Use and our Privacy Policy. If you do not
//               agree, you will not be able to complete the purchase.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">
//                 5. Consent Based on Your Use of Our Website:
//               </span>
//               Even if you do not consent to be bound by our Terms of Use and
//               Privacy Policy at the time of purchase, please be aware that we
//               will rely on your continued use of our website as confirmation of
//               your consent to be bound if applicable law permits us to do so.
//               Your consent applies to our Terms of Use and Privacy Policy as
//               they may be updated from time to time. If you do not want to be
//               bound, please do not visit or use or website.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des"> 6. Personal Data:</span>
//               Here is a summary of how we acquire and use personal data of
//               website visitors and others.
//             </p>

//             <div className="privacyinfo_head_sub_head_des">
//               <p>
//                 <span className="privacyinfo_head_des">(a).</span> We collect
//                 some personal data through cookies, when you register as a user
//                 of our website, and when you purchase products and services
//                 through our website.
//               </p>

//               <p>
//                 <span className="privacyinfo_head_des">(b).</span> The personal
//                 data we collect and process may include your name, IP addresses,
//                 geolocation information, passwords, email addresses, mailing
//                 addresses, telephone numbers, professional status, transaction
//                 and traffic data.
//               </p>

//               <p>
//                 <span className="privacyinfo_head_des"> (c).</span> We do not
//                 currently collect sensitive personal information such as Social
//                 Security numbers, age, driver’s license numbers, , usernames, or
//                 information on race, ethnicity, religious or philosophical
//                 beliefs. Please monitor our Terms of Use and Privacy Policy for
//                 any changes in the future.
//               </p>

//               <p>
//                 <span className="privacyinfo_head_des">(d) .</span>We act as the
//                 controller of the personal data that we collect, and we may
//                 enter into written contracts with service providers who assist
//                 us in processing personal data.
//               </p>
//             </div>
//             <p>
//               <span className="privacyinfo_head_des">
//                 7. What We Do with Your Personal Data:
//               </span>
//               As a general rule, we use your personal data only for the purposes
//               that are described in this Privacy Policy, and only to the extent
//               that our use of your personal data is reasonable and relevant to
//               these purposes.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(a).</span> We use your
//               personal data only for the following purposes: (a) Monitoring and
//               maintaining the functionality of our website to make sure it is
//               operating correctly; (b) Communicating with our customers and
//               website visitors and users; (c) Market research and marketing of
//               the products and services of Parlay Roial; and (iv) Detecting any
//               use of our website that violates our Terms of Use.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(b).</span> We do not keep
//               personal data any longer than is necessary for business purposes,
//               and we delete personal data when it is no longer necessary.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des"> (c).</span> We use our
//               commercially reasonable best efforts to maintain the security of
//               the personal data that we collect and use.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(d).</span> We do not buy
//               or sell personal data, and we do not share personal data except
//               with third parties who agree to comply with applicable privacy
//               law.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(e).</span> We do not use
//               automated decision-making technology such as “profiling.”
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(f).</span> We use your
//               personal data to communicate with you at our website and by email
//               to make you aware of the information, products and services that
//               are available through Parlay Roial, to provide customer service,
//               and to conduct surveys.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(g).</span> We reserve the
//               right to retain and disclose personal data (i) when we are legally
//               required to do so by law or court order, (ii) when it is necessary
//               to do so to enforce the Terms of Use, and/or (iii) to protect the
//               rights, safety or security of Parlay Roial, our advertisers and
//               affiliates, and our employees, contractors, and vendors.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">
//                 8. Your Privacy Rights:
//               </span>
//               Depending on what laws apply to your use of our website and our
//               collection of personal data, which may change from time to time in
//               the future, you may have the following rights regarding your
//               personal data, and you may exercise any of the rights you have by
//               contacting our Data Protection Officer at [Insert email address].
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(a).</span> The right to
//               withdraw your consent to the use of cookies.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(b).</span> The right to
//               withdraw your consent to the collection and processing of your
//               personal data.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(c).</span> The right to
//               request a copy of your personal data that we have collected.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(d).</span> The right to
//               update, correct, change, block or erase your personal data.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(e).</span> The right to
//               transfer some or all of your personal data to another data
//               controller.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(f).</span> The right to
//               limit the use and disclosure of sensitive personal information.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">(g).</span> The right to
//               opt out of receiving marketing communications from us by email.
//             </p>

//             <p>
//               <span className="privacyinfo_head_des">
//                 9. Privacy Policy for Minors
//               </span>
//             </p>
//             <p>
//               <span className="privacyinfo_head_des">(a).</span> Our website,
//               and our products and services, offers content that is intended for
//               use by children but only with the consent and under the
//               supervision of their parents or guardians. However, access to the
//               content requires a purchase, and only users who are 18 years of
//               age or older are permitted to make purchases. We rely on these
//               users to decide whether our content is appropriate for any minor
//               with whom the content will be shared. We do not target or provide
//               information, products or services directly to minors.
//             </p>
//             <p>
//               <span className="privacyinfo_head_des">(b).</span> We do not
//               knowingly collect personal data from minors.
//             </p>
//             <p>
//               <span className="privacyinfo_head_des"> (c).</span> If an
//               individual under the age of 18 wishes to purchase products or
//               services from our website, the individual’s parent or guardian
//               must provide verifiable written consent at the time of sign-up.
//             </p>
//             <p>
//               <span className="privacyinfo_head_des">
//                 10. Scope of Privacy Policy:
//               </span>
//             </p>
//             <p>
//               <span className="privacyinfo_head_des"> (a).</span> Our Privacy
//               Policy applies only to personal data that we collect when you
//               visit and use our website, and not to information that we collect
//               through our off-line business.
//             </p>
//             <p>
//               <span className="privacyinfo_head_des">(b).</span> Our Privacy
//               Policy does not apply to other websites that may be linked to our
//               website, including websites operated by advertisers and other
//               third parties. If you leave our website and go to another website,
//               please be careful to read the Terms of Use and Privacy Policy that
//               is posted at the other website.
//             </p>
//             <p>
//               <span className="privacyinfo_head_des">11. Contact:</span> If you
//               have any questions about our Terms of Use and Privacy Policy,
//               please contact the Data Privacy Officer for Parlay Roial at
//               [Insert email address].
//             </p>
//           </div>
//           <div className="privacy_end_data">
//             <h3>– End of Privacy Policy – </h3>
//             <h3>Last Updated July 28, 2021 </h3>
//           </div>
//         </div>
//       </div>
//     </Grid>
//   );
// }


import React from "react";
import {
    makeStyles, Typography, Container, Box,
    Grid,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
} from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        padding: theme.spacing(2),
        backgroundColor: theme.palette.white,
        position: "relative",
        [theme.breakpoints.down('sm')]:{
            
            marginTop:'100px'
        }

    },
    title: {
        // width: "40%",
        // height: "auto",
        // objectFit: "cover",
        // [theme.breakpoints.down("xs")]: {
        //     width: "60%",
        // },
        fontSize: "20px",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
        // marginLeft: "25%",
        textAlign: "center",
        marginTop: "6%",
    },
    footertitle: {
         // },
         alignItems: "center",
         alignContent: "center",
         justifyContent: "center",
         textAlign: "center",
    }

}));

export default function PrivacyPolicy() {
    const classes = useStyles();
    return (
          <Grid style={{ minHeight: "420vh" }} container>
        <div id="privacypolicy" className={classes.root}>
            <Container maxWidth="md">
                <Box mb={2} className={classes.title}>
                    <h2>Continent 5 Media Group, Inc.</h2>
                    <h3>PRIVACY POLICY</h3>

                </Box>
                <Box textAlign="justify">
                    <Typography color="primaryText" variant="body1">
                        Continent 5 Media Group, Inc. complies with all applicable privacy laws. Our Privacy Policy is intended to
                        explain how we collect and use personal data when you use our websites and to alert you to the rights you may
                        have to control how the personal data is collected and used.

                    </Typography>
                    <br />
                    <Typography color="primaryText" variant="body1">
                        “Continent 5 Media,” “C5M,” “we,” “our,” and “us” refer to Continent 5 Media Group, Inc., and “you” and
                        “yours” refers to visitors and users of our websites.
                    </Typography>
                    <br />
                    <Typography color="primaryText" variant="body1">
                        1.<span style={{ fontWeight: 'bold', marginLeft: "2rem"}}>Websites.</span>  Our Terms of Use and Privacy Policy apply to the following websites:
                    </Typography>
                    <br />
                    <Typography color="primaryText" variant="body1">
                        <Link style={{lineHeight: '40px'}} href="#">www.AskTheLawGuru.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.BigBangRecords.ca</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.C5M.world</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.Continent5Media.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.Continent5MediaGroup.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.CounterstrikeEntertainment.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.Decade2Publishing.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.eksplode.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.FederalLawWiz.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.GalaxieRecordsUSA.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.GalaxieMusic.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.GalleryAurora.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.ImpactRecords.ca</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.KleverBook.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.LevelSupra.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.Mind4Law.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.OperationVegasIce.com</Link><br />
                        <Link style={{lineHeight: '40px'}} href="#">www.PaperJumsuit.com</Link><br />
                        <Link style={{lineHeight: '40px'}}href="#">www.TitanMobileGaming.com</Link><br />
                    </Typography>
                    <Typography color="primaryText" variant="body1">
                        The owner of these websites is Continent 5 Media Group. To contact us, please send an email to<br />
                        <Link href="#">Admin@continent5media.com</Link> or <Link href="#">Admin@c5m.world.</Link>
                    </Typography>
                    <Typography color="primaryText" variant="body1">
                        2.<span style={{ fontWeight: 'bold', marginLeft: "2rem" }}>Most Recent Update.</span> Our Terms of Use and Privacy Policy were last updated on September 22, 2022.
                        Please return to our Terms of Use and Privacy Policy to find out if we have made any changes since your last
                        visit.

                    </Typography>
                    <Typography color="primaryText" variant="body1">
                        3.<span style={{ fontWeight: 'bold', marginLeft: "2rem" }}>Consent to Use of Cookies. </span>
                        Like virtually all websites, our websites use “cookies” that are
                        automatically installed on your computer when you visit our websites. Cookies are small text files stored on
                        your computer and can be recognized when you return to our websites. Some cookies are installed by the
                        service providers who host and maintain our websites or advertisers. Some of your personal data will be
                        collected by the cookies. On the landing page, you will be given an opportunity to consent (or “opt in”) to the
                        use of cookies. If you do not opt in, or if you opt in, but you later remove or disable the cookies, the website(s)
                        will not be fully functional.
                    </Typography>
                    <Typography color="primaryText" variant="body1">
                        4.<span style={{ fontWeight: 'bold', marginLeft: "2rem" }}>Consent to Terms of Use and Privacy Policy.</span> When you purchase products or services through
                        C5M’s websites, you will be asked to confirm that you agree to be bound by our Terms of Use and our Privacy
                        Policy. If you disagree, you will not be able to complete the purchase.
                        visit.

                    </Typography>
                    <Typography color="primaryText" variant="body1">
                        5.<span style={{ fontWeight: 'bold', marginLeft: "2rem" }}>Consent Based on Your Use of Our Websites.</span> Even if you do not consent to be bound by our Terms
                        of Use and Privacy Policy at the time of purchase, please be aware that we will rely on your continued use of
                        our websites as confirmation of your consent to be bound if applicable law permits us to do so. Your consent
                        applies to our Terms of Use and Privacy Policy, which may be updated occasionally. Please do not visit or use
                        our websites if you do not want to be bound.

                    </Typography>
                    <Typography color="primaryText" variant="body1">
                        6.<span style={{ fontWeight: 'bold', marginLeft: "2rem" }}>Personal Data.</span> Here is a summary of how we acquire and use visitors’ personal data on our websites.
                        <br />
                        <span style={{ padding: "2.5rem" }}>(a)&nbsp;&nbsp;&nbsp;&nbsp;We collect some personal data through cookies when you register as a user of our website(s) and
                        when you purchase products and services through our websites.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(b)&nbsp;&nbsp;&nbsp;&nbsp;The personal data we collect and process may include your name, IP address, geolocation
                        information, passwords, email addresses, mailing addresses, telephone numbers, professional status, transaction,
                        and traffic data.</span>

                        <br />
                        <span style={{ padding: "2.5rem" }}>(c)&nbsp;&nbsp;&nbsp;&nbsp;;We do not currently collect sensitive personal information such as Social Security numbers, age,
                        driver’s license numbers, usernames, or information on race, ethnicity, religious or philosophical beliefs. Please
                        monitor our Terms of Use and Privacy Policy for any changes in the future.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(d)&nbsp;&nbsp;&nbsp;&nbsp;We act as the controller of the personal data we collect, and we may enter into written contracts
                        with service providers who assist us in processing personal data.</span>
                    </Typography>
                    <Typography color="primaryText" variant="body1">
                        7.<span style={{ fontWeight: 'bold', marginLeft: "2rem" }}>What We Do with Your Personal Data.
                        </span> As a general rule, we use your personal data only for the
                        purposes described in this Privacy Policy and only to the extent that our use of your personal data is reasonable
                        and relevant to these purposes.
                        </Typography>
                        <br />
                        <Typography color="primaryText" variant="body1">
                        <span style={{ padding: "2.5rem" }}>(a)&nbsp;&nbsp;&nbsp;&nbsp;We use your personal data only for the following purposes: (a) Monitoring and maintaining the
                        functionality of our websites to make sure it is operating correctly; (b) Communicating with our customers and
                        websites visitors and users; (c) Market research and marketing of the products and services of C5M and its
                        subsidiaries; and (iv) Detecting any use of our websites that violates our Terms of Use.</span>
                        <br />

                        <span style={{ padding: "2.5rem" }}>(b)&nbsp;&nbsp;&nbsp;&nbsp;We do not keep personal data any longer than is necessary for business purposes, and we delete
                        personal data when it is no longer required.</span>

                        <br />
                        <span style={{ padding: "2.5rem" }}>(c)&nbsp;&nbsp;&nbsp;&nbsp;We use our commercially reasonable best efforts to maintain the security of the personal data
                        that we collect and use.</span>

                        <br />
                        <span style={{ padding: "2.5rem" }}>(d)&nbsp;&nbsp;&nbsp;&nbsp;We do not buy or sell personal data, and we do not share personal data except with third parties
                        who agree to comply with applicable privacy laws.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(e)&nbsp;&nbsp;&nbsp;&nbsp;We do not use automated decision-making technology such as “profiling.”</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(f)&nbsp;&nbsp;&nbsp;&nbsp;We use your data to communicate with you on our websites and by email to make you aware of
                        the information, products, and services that are available through C5M, to provide customer service, and to conduct surveys.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(g)&nbsp;&nbsp;&nbsp;&nbsp;We reserve the right to retain and disclose personal data (i) when we are legally required to do so
                        by law or court order, (ii) when it is necessary to do so to enforce the Terms of Use, and/or (iii) to protect the
                        rights, safety or security of C5M, our advertisers and affiliates, and our employees, contractors, and vendors.</span>
                        </Typography>
                    
                    <Typography color="primaryText" variant="body1">
                        8.<span style={{ fontWeight: 'bold', marginLeft: "2rem" }}>Your Privacy Rights.</span> Depending on what laws apply to your use of our websites and our collection of
                        personal data, which may change from time to time in the future, you may have the following rights regarding
                        your personal data, and you may exercise any of the rights you have by contacting our Data Protection Officer
                        at <Link href='#'>Admin@Continent5Media.com</Link> or <Link>Admin@C5M.com</Link>:
                        <br />
                        <span style={{ padding: "2.5rem" }}>(a)&nbsp;&nbsp;&nbsp;&nbsp;The right to withdraw your consent to the use of cookies.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(b)&nbsp;&nbsp;&nbsp;&nbsp;The right to withdraw your consent to the collection and processing of your personal data.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(c)&nbsp;&nbsp;&nbsp;&nbsp;The right to request a copy of your personal data that we have collected.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(d)&nbsp;&nbsp;&nbsp;&nbsp;The right to update, correct, change, block, or erase your personal data.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(e)&nbsp;&nbsp;&nbsp;&nbsp;The right to transfer some or all of your personal data to another data controller.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(f)&nbsp;&nbsp;&nbsp;&nbsp;The right to limit the use and disclosure of sensitive personal information.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(g)&nbsp;&nbsp;&nbsp;&nbsp;The right to opt out of receiving marketing communications from us by email.</span>
                    </Typography>
                    <Typography color="primaryText" variant="body1">

                        9.<span style={{ fontWeight: 'bold', marginLeft: "2rem" }}>Privacy Policy for Minors. </span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(a)&nbsp;&nbsp;&nbsp;&nbsp;Some of our websites offer programs and content that is intended for use by children but only
                        with the consent and under the supervision of their parents or guardians. However, access to the content allows
                        for purchases of products and services, and only users 18 years of age or older are permitted to make purchases.
                        We rely on these users to decide whether our content is appropriate for any minor with whom the content will
                        be shared.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(b)&nbsp;&nbsp;&nbsp;&nbsp;We do not knowingly collect personal data from minors.</span>

                        <br />
                        <span style={{ padding: "2.5rem" }}>(c)&nbsp;&nbsp;&nbsp;&nbsp;Individuals under the age of thirteen must ask their parent or guardian for permission to use our
                        websites,</span>
                        <br />
                    </Typography>
                    <Typography color="primaryText" variant="body1">

                        10.<span style={{ fontWeight: 'bold', marginLeft: "2rem" }}>Scope of Privacy Policy. </span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(a)&nbsp;&nbsp;&nbsp;&nbsp;Our Privacy Policy applies only to personal data that we collect when you visit and use our
                        websites and not to information that we collect through our offline business.</span>
                        <br />
                        <span style={{ padding: "2.5rem" }}>(b)&nbsp;&nbsp;&nbsp;&nbsp;Our Privacy Policy does not apply to other websites that may be linked to our websites,
                        including websites operated by advertisers and other third parties. If you leave our website(s) and go to another,
                        please be careful to read the Terms of Use and Privacy Policy posted on the other website.</span>

                    </Typography>
                    <Typography color="primaryText" variant="body1">

                        11.<span style={{ fontWeight: 'bold', marginLeft: "2rem" }}>Contact.</span> If you have questions about our Terms of Use and Privacy Policy, don't hesitate to contact the
                        Data Privacy Officer for C5M at<Link href='#'> Admin@Continent5Media.com</Link> or <Link>Admin@C5M.com</Link>:
                    </Typography>
                    <br/>
                    <br/>
                    <br/>                    
                    <Typography className={classes.footertitle} color="primaryText" variant="body1">
                        – End of Privacy Policy – <br />
                        Last Updated September 22, 2022
                    </Typography>
                </Box>
            </Container>
        </div>
        </Grid>
    );
};

